import appConfig from '@nerdwallet/app-config';
import { MARKETPLACE } from '@nerdwallet/structured-content/types/providers';

import { DATA_DEPENDENCY_TYPES } from '../constants';
import nwApiSdk from '../nw-api-sdk';

const createProviders = ({
  serverRequest: req,
  includeInactiveOrNonMonetizingProducts,
}) => () => ({
  /**
   * Default data provider for rendering Marketplace, data-dependent components like [marketplace_field] inside of editorial content.
   * @todo - Expose providers as a top-level package export in `@nerdwallet/structured-content`.
   */
  [MARKETPLACE]: () =>
    import('@nerdwallet/structured-content/dist/providers/marketplace').then(
      (module) =>
        module.default({
          appConfig,
          nwApiSdk,
          serverRequest: req,
        })
    ),
  /**
   * LPC component data provider definitions.
   */
  [DATA_DEPENDENCY_TYPES.ALPS]: () =>
    import('../alps/create-providers/credit-cards').then((module) =>
      module.default({ req })
    ),
  [DATA_DEPENDENCY_TYPES.ALPSBANKING]: () =>
    import('../alps/create-providers/banking').then((module) =>
      module.createAlpsBankingProvider({
        req,
        includeInactiveOrNonMonetizingProducts,
      })
    ),
  [DATA_DEPENDENCY_TYPES.ALPSCDS]: () =>
    import('../alps/create-providers/banking').then((module) =>
      module.createAlpsCdsProvider({
        req,
        includeInactiveOrNonMonetizingProducts,
      })
    ),
  [DATA_DEPENDENCY_TYPES.ALPSINVESTING]: () =>
    import('../alps/create-providers/investing').then((module) =>
      module.default({ req })
    ),
  [DATA_DEPENDENCY_TYPES.CREDIT_CARDS]: () =>
    import('../credit-cards/provider').then((module) =>
      module.default({ req, includeInactiveOrNonMonetizingProducts })
    ),
  [DATA_DEPENDENCY_TYPES.INVESTING]: () =>
    import('../investing/provider').then((module) =>
      module.default({ req, includeInactiveOrNonMonetizingProducts })
    ),
  [DATA_DEPENDENCY_TYPES.PERSONAL_LOANS]: () =>
    import('../personal-loans/provider').then((module) =>
      module.default({ req })
    ),
  [DATA_DEPENDENCY_TYPES.STUDENT_LOANS]: () =>
    import('../student-loans/provider').then((module) =>
      module.default({ req })
    ),
  [DATA_DEPENDENCY_TYPES.MORTGAGES]: () =>
    import('../mortgages/provider').then((module) => module.default({ req })),
  [DATA_DEPENDENCY_TYPES.BANKING]: () =>
    import('../banking/provider').then((module) =>
      module.default({
        req,
        includeInactiveOrNonMonetizingProducts,
      })
    ),
  [DATA_DEPENDENCY_TYPES.SAVINGS]: () =>
    import('../banking/provider').then((module) =>
      module.createSavingsProvider({
        req,
        includeInactiveOrNonMonetizingProducts,
      })
    ),
  [DATA_DEPENDENCY_TYPES.CHECKING]: () =>
    import('../banking/provider').then((module) =>
      module.createCheckingProvider({
        req,
        includeInactiveOrNonMonetizingProducts,
      })
    ),
  [DATA_DEPENDENCY_TYPES.CDS]: () =>
    import('../cds/provider').then((module) => module.default({ req })),
});

export default createProviders;
